<template>
	<div class="h-full flex justify-center">
		<div class="flex flex-col h-full w-full max-w-xl">
			<div class="grow px-3 sm:px-5 my-3 2xl:my-6">
				<div class="h-full flex flex-col justify-center">
					<ejs-dialog
						:buttons='alertDlgButtons'
						ref="alertDialog"
						v-bind:visible="false"
						:header='alertHeader'
						:animationSettings='animationSettings'
						:content='alertContent'
						:showCloseIcon='false'
						target='.control-section'
						width='550px'
						:isModal='true'>
					</ejs-dialog>
					<offer-request />
					<panel :title="$t('eny.checklist')" addclass="mt-4">
						<form id="privacy-consent-data-form">
							<div class="flex flex-col">
								<!-- Base conditions check list -->
								<div class="lg:mx-44 mt-7 form-group">
									<div class="flex flex-row items-center justify-between">
										<div class="grow">{{$t('eny.checklist_entry.age')}}</div>
										<ejs-switch :checked="confirmed.age" css-class="eny-context flex-none" @change="(args) => onSwitchChange(args, 'age')"></ejs-switch>
									</div>
									<div class="mt-7 flex flex-row items-center justify-between">
										<div class="grow">{{$t('eny.checklist_entry.residence')}}</div>
										<ejs-switch :checked="confirmed.residence" css-class="eny-context flex-none" @change="(args) => onSwitchChange(args, 'residence')"></ejs-switch>
									</div>
									<div class="mt-7 flex flex-row items-center justify-between">
										<div class="grow">{{$t('eny.checklist_entry.income')}}</div>
										<ejs-switch :checked="confirmed.income" css-class="eny-context flex-none" @change="(args) => onSwitchChange(args, 'income')"></ejs-switch>
									</div>
									<div class="mt-7 flex flex-row items-center justify-between">
										<div class="grow">{{$t('eny.checklist_entry.proceedings')}}</div>
										<ejs-switch :checked="confirmed.proceedings" css-class="eny-context flex-none" @change="(args) => onSwitchChange(args, 'proceedings')"></ejs-switch>
									</div>
								</div>
							</div>
						</form>
					</panel>
					<!-- Buttons -->
					<div class="w-full px-10 md:px-20 py-3 2xl:pt-6 flex flex-row justify-center gap-2 sm:gap-6">
						<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="prevStep">{{$t('eny.back')}}</button>
						<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="nextStep">{{$t('eny.forward')}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { CheckBoxComponent, SwitchComponent } from "@syncfusion/ej2-vue-buttons";
import { DialogComponent } from "@syncfusion/ej2-vue-popups";
import Panel from "../../Base/Panel.vue";
import OfferRequest from "./Request.vue";
import useNotification from "../../hooks/useNotification";

export default {
	name: "CheckList",
	components: {
		'panel': Panel,
		'offer-request': OfferRequest,
		'ejs-checkbox': CheckBoxComponent,
		'ejs-dialog': DialogComponent,
		'ejs-switch': SwitchComponent,
	},
	setup() {
		const { showNotification, hideNotification } = useNotification();
		return {
			showNotification,
			hideNotification,
		}
	},
	data() {
		return {
			confirmed: {
				age: false,
				residence: false,
				income: false,
				proceedings: false
			},
			// dialog data
			alertHeader: this.$t('eny.we_re_sorry'),
			alertContent: '',
			animationSettings: { effect: 'None' },
			alertDlgButtons: [
				{ click: this.offerCloseDlgBtnClick, buttonModel: { content: this.$t('eny.end_application'), isPrimary: false } },
				{ click: this.correctDlgBtnClick, buttonModel: { content: this.$t('eny.correct'), isPrimary: true } }
			],
		};
	},
	mounted() {
		this.confirmed.age = this.confirmed.residence = this.confirmed.income = this.confirmed.proceedings = this.request_base_confirmed;
		this.$store.dispatch('customer/update_offer_step', 0);
	},
	computed: {
		...mapGetters('customer', ['request', 'request_base_confirmed', 'success', 'message']),
	},
	methods: {
		onSwitchChange(args, elName) {
			this.confirmed[elName] = args.checked;
		},
		offerCloseDlgBtnClick: function() {
			this.$store.dispatch('customer/store_status', 3);
			this.$store.dispatch('customer/reset');
			this.$refs.alertDialog.hide();
			this.$router.push('/offer');
		},
		correctDlgBtnClick: function() {
			this.$refs.alertDialog.hide();
		},
		prevStep: function() {
			this.$router.push('/offer');
		},
		nextStep: function() {
			const base_confirmed = this.confirmed.age && this.confirmed.residence && this.confirmed.income && this.confirmed.proceedings
			if (base_confirmed) {
				this.$router.push('/offer/applicant')
				this.$store.dispatch('customer/store_request_base_confirmed', true)
			} else {
				this.alertContent = "Die Grundbedingungen sind nicht erfüllt. Bitte korrigieren Sie die Eingaben, um einen Kredit beantragen zu können."
				this.$refs.alertDialog.show()
			}
		},
	},
	watch: {
		message(value) {
			if (value !== '') {
				this.showNotification(value, this.success ? 'info ': 'error', 5);
			}
		},
	}
}
</script>
<style>
</style>
